import { getAxiosClient } from "../../axios-client";
import {
  DeleteOfferSubcontractorRequestBody,
  DeleteOfferSubcontractorResponse,
} from "./types";

const axiosClient = getAxiosClient();
export const deleteOfferSubcontractor = async (
  body: DeleteOfferSubcontractorRequestBody
) => {
  return await axiosClient.ax.delete<DeleteOfferSubcontractorResponse>(
    "/Offers/DeleteOfferSubcontractor",
    { data: body }
  );
};
